import { render, staticRenderFns } from "./viewAccount.vue?vue&type=template&id=6f4bceea&scoped=true"
import script from "./viewAccount.vue?vue&type=script&lang=js"
export * from "./viewAccount.vue?vue&type=script&lang=js"
import style0 from "./viewAccount.vue?vue&type=style&index=0&id=6f4bceea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4bceea",
  null
  
)

export default component.exports